export default __webpack_public_path__ + "static/media/003-horror.95e0db6a.svg";